import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';
import { map } from 'rxjs/operators';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ICommunityProfile } from '../../types/api-response/community/profile';
import { ITopic, ITopicQueryParameters } from '../../types/api-response/community/topic';
import { IComment } from '../../types/api-response/community/comment';

@Injectable()
export class CommunityApiService {

  constructor(private api: ApiClientService) {}

  /**
   * Returns community user profile details
   */
  getMyProfile(): Observable<ICommunityProfile> {
    const url = `/v1/user_profile/me.json`;

    return this.api.get('domainCommunity', url).pipe(
      map((response: Response) => response.json())
    );
  }

  /**
   * Register new user in community
   *
   * @param user
   */
  setProfile(user: ICommunityProfile): Observable<{id: string}> {
    const url = `/v1/user_profile.json`;

    return this.api.post('domainCommunity', url, user);
  }


  /**
   * Returns topics list
   *
   * @param params
   */
  topicGetList(params: ITopicQueryParameters = {}): Observable<{entities: ITopic[], total: number}> {
    const url = '/v1/topic.json' + ApiClientService.serialize(params);

    return this.api.get('domainCommunity', url).pipe(
      map(result => result.json())
    );
  }

  /**
   * Returns topic by ID
   *
   * @param topicId
   */
  topicGet(topicId) {
    const url = `/v1/topic/${topicId}.json`;

    return this.api.get('domainCommunity', url).pipe(
      map(result => result.json())
    );
  }

  /**
   * Sets new topic
   *
   * @param topic
   */
  topicCreate(topic: ITopic): Observable<ITopic> {
    const url = `/v1/topic.json`;

    return this.api.post('domainCommunity', url, topic);
  }

  /**
   * Updates topic by ID
   *
   * @param id
   * @param topic
   */
  topicUpdate(id: string, topic: ITopic): Observable<ITopic> {
    const url = `/v1/topic/${id}.json`;

    return this.api.patch('domainCommunity', url, topic);
  }

  /**
   * Removes topic by ID
   *
   * @param id
   */
  topicDelete(id: string) {
    const url = `/v1/topic/${id}.json`;

    return this.api.remove('domainCommunity', url);
  }

  /**
   * Marks selected topic as liked
   *
   * @param id
   */
  topicLike(id: string): Observable<{current: number}> {
    const url = `/v1/topic/${id}/like.json`;

    return this.api.post('domainCommunity', url);
  }

  /**
   * Removes likes mark from selected topic
   *
   * @param id
   */
  topicUnlike(id: string): Observable<{current: number}> {
    const url = `/v1/topic/${id}/like.json`;

    return this.api.remove('domainCommunity', url);
  }

  /**
   * Marks selected topic as read
   *
   * @param id
   */
  topicMarkRead(id: string): Observable<{current: number}> {
    const url = `/v1/topic/${id}/read.json`;

    return this.api.post('domainCommunity', url);
  }

  /**
   * Subscribes on selected topic
   *
   * @param id
   */
  topicSubscribe(id: string): Observable<{current: number}> {
    const url = `/v1/topic/${id}/subscribe.json`;

    return this.api.post('domainCommunity', url);
  }

  /**
   * Unsubscribes from selected topic
   *
   * @param id
   */
  topicUnsubscribe(id: string): Observable<{current: number}> {
    const url = `/v1/topic/${id}/subscribe.json`;

    return this.api.remove('domainCommunity', url);
  }

  /**
   * Adds comment for selected topic ID
   *
   * @param id
   * @param comment
   */
  topicCommentCreate(id: string, comment: IComment) {
    const url = `/v1/topic/${id}/comment.json`;

    return this.api.post('domainCommunity', url, comment);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/community-api.service.ts